import React, { useContext, useEffect, useState } from 'react';
import {
  Loan,
  LoanDocState,
  Task,
  TaskResponse,
  TaskState
} from '../../../../../../gql/graphql';
import { TaskContext } from '../Insurance';
import ModalFinishTask from './ModalFinishTask';
import { useGetTaskResponsesByTask } from '../../../../../../services/task/querys';
import { Form } from 'antd';
import SectionErrorTask from 'scenes/Private/components/SectionErrorTask/SectionErrorTask';
import SectionSuccessTask from 'scenes/Private/components/SectionSuccessTask/SectionSuccessTask';
import CollapseIssues from 'scenes/Private/components/CollapseIssues/CollapseIssues';
import Contact from './Contact';
import arrowBlue from 'assets/images/arrow-blue.png';
import { OBIE_LINK, OBIE_LOGO } from '../insurance.constant';
import constLogo from '../../../../../../assets/images/constlending-logo.svg';
import Documents from './Documents';
import { LoanContext } from '../../../Dashboard';
import { useGetLoanDocByLoan } from '../../../../../../services/loan/querys';

interface IForm {
  titleCompany: string;
  name: string;
  phone: string;
  email: string;
}

interface Props {
  setStep: Function;
  closeTask: Function;
  responsesStep1?: any;
  optionStep1Select?: {id: number; title: string;};
}

const Step2 = ({ setStep, closeTask, responsesStep1, optionStep1Select }: Props) => {
  const [form] = Form.useForm();
  const task: Task | any = useContext(TaskContext);
  const loan: Loan | any = useContext(LoanContext);

  const { data: loanDocs } = useGetLoanDocByLoan({ variables: { loanId: loan._id } });
  const { data: taskResponses, reexecute: getTaskResponses } = useGetTaskResponsesByTask({
    variables: { findResponsesByTask: { taskId: task._id } }
  });

  const [modalFinishTask, setModalFinishTask] = useState<boolean>(false);
  const [responseInfo, setResponseInfo] = useState<TaskResponse | any>();
  const [responseDoc, setResponseDoc] = useState<TaskResponse | any>();
  const [taskCompleted, setTaskCompleted] = useState<boolean>();

  useEffect(() => {
    getTaskResponses({ requestPolicy: 'network-only' });
  }, []);

  useEffect(() => {
    if (responseInfo && responseInfo.state !== TaskState.RequestError)
      form.setFieldsValue(responseInfo.metadata);
  }, [responseInfo])

  const isLoanDocsInsurance = loanDocs?.find(item => item.key === 'insurance')?.state == LoanDocState.Approved;
  const isContact = optionStep1Select?.id === 2;
  const isDocument = optionStep1Select?.id === 3;

  useEffect(() => {
    const _response = taskResponses?.find((item) => item.step === 2 && item.key === 'insurance-information');
    setResponseInfo(_response);

    const _response2 = taskResponses?.find((item) => item.step === 2 && item.key === 'insurance-doc');
    setResponseDoc(_response2);

    setTaskCompleted(isLoanDocsInsurance && (_response?.state === TaskState.Approved || _response2?.state === TaskState.Approved));
  }, [taskResponses]);

  return (
    <section className='insurance-step-2 '>
      <div className="section-1">
        <section>
          <h3 className="h3">
            {isContact && 'Who is your current insurance agent?'}
            {isDocument && 'Upload your insurance documents'}
          </h3>

          <div className="mt-10">
            <p className="description h4-w4">
              {isContact && 'We’ll reach out and get insurance documents. Before your insurance is approved, you can choose a different insurance type by reopening this task and choosing another option.'}
              {isDocument && 'Before your insurance is approved, you can choose a different insurance type by reopening this task and choosing another option.'}
            </p>
          </div>

          {taskCompleted &&
            <SectionSuccessTask
              title="You've completed this task."
              button={{ title: "Back to dashboard", onClick: closeTask }}
            />
          }

          {!taskCompleted && 
            <SectionErrorTask
              taskId={task._id}
              taskResponseKey={isContact? 'insurance-information': 'insurance-doc'}
              componentDataError={(textDataError: any) => (
                <div className='text-data'>
                  <div className='row'>
                    <span>Insurance company name</span>
                    <b>{textDataError.insuranceCompany}</b>
                  </div>
                  <div className='row'>
                    <span>Contact name</span>
                    <b>{textDataError.name}</b>
                  </div>
                  <div className='row'>
                    <span>Phone number</span>
                    <b>{textDataError.phone}</b>
                  </div>
                  <div className='row'>
                    <span>Email address</span>
                    <b>{textDataError.email}</b>
                  </div>
                </div>
              )}
            />
          }

          {isContact && <Contact disabled={isLoanDocsInsurance} onModalFinish={() => setModalFinishTask(true)}/>}
          {isDocument && <Documents disabled={isLoanDocsInsurance} onModalFinish={() => setModalFinishTask(true)}/>}
        </section>

        <div className='footer'>
          <div className='icons-container'>
            {[OBIE_LOGO, constLogo].map((icon, index) => (
              <img key={index} src={icon} className="lienzo" alt="lienzoSvg" />
            ))}
            {' '}
          </div>
          <span className="blue-bold" onClick={() => window.open(OBIE_LINK, '_blank')}>
            Request a quote from our partner instead
            <img src={arrowBlue} className="arrow" alt="arrow" />
          </span>
        </div>
      </div>

      <CollapseIssues taskId={task._id} taskKey={task.key} rejectionCode='no_action_required' />

      <ModalFinishTask
        visible={modalFinishTask}
        setVisible={setModalFinishTask}
        closeTask={closeTask}
      />
    </section>
  );
};
export default Step2;
